import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { officeTripsImage } from 'assets/media/corporateEvents';
import OfficeTripsForm from './Form';
import styles from './OfficeTrips.module.scss';

const OfficeTrips = () => {
  const { t } = useTranslation();

  return (
    <Row className={styles.Container}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <h2 className={styles.Title}>{t('pages.corporateEvents.officeTrips')}</h2>
            <p className={styles.Description}>
              {t('pages.corporateEvents.officeTripsDescription')}
            </p>
          </Col>
        </Row>
        <Row justify="space-between" gutter={{ sm: 40 }}>
          <Col xs={0} sm={12}>
            <img className={styles.Image} src={officeTripsImage} alt="Office Trips" />
          </Col>
          <Col xs={24} sm={12}>
            <OfficeTripsForm />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default OfficeTrips;
